import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useErpAuth } from '../../context/ErpAuthContext';

const FORCE_CHANGE_PATH = '/erp/cambiar-contrasena';

export function ErpProtectedRoute() {
  const { isAuthenticated, loading, user } = useErpAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="erp-login-page">
        <p style={{ color: 'white' }}>Cargando…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/erp/login" replace />;
  }

  if (user?.mustChangePassword && location.pathname !== FORCE_CHANGE_PATH) {
    return <Navigate to={FORCE_CHANGE_PATH} replace />;
  }

  return <Outlet />;
}

export function ErpGuestRoute() {
  const { isAuthenticated, loading } = useErpAuth();

  if (loading) {
    return (
      <div className="erp-login-page">
        <p style={{ color: 'white' }}>Cargando…</p>
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/erp" replace />;
  }

  return <Outlet />;
}
